import mapValues from "lodash/mapValues";

// Taken from lodash https://www.npmjs.com/package/lodash.isobject, because Sonar complains about the package not being updated for 5 years
function isObject(value: any) {
    const type = typeof value;
    return !!value && (type === "object" || type === "function");
}

// https://github.com/lodash/lodash/issues/1244#issuecomment-338139221
// A function that creates a new object from a source object by iterating over all object values and passing them to a callback.
// The keys of the new object will stay the same, while the callback can modify the values. The source object will not be mutated.
export const mapValuesDeep = (obj: any, cb: (v: any) => any): any => {
    if (Array.isArray(obj)) {
        return obj.map((innerObj: any) => mapValuesDeep(innerObj, cb));
    } else if (isObject(obj)) {
        return mapValues(mapValues(obj, cb), (val) => mapValuesDeep(val, cb));
    } else {
        return cb(obj);
    }
};
